import React from 'react';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';
import Text from '../text/text.component';

interface Props extends Layer, Gap, TestId {
  /** The components's title, rendered above the number */
  title: string;

  /** The number to render */
  number: number | string;

  /** A (descriptive) text, rendered underneath the number */
  text: React.ReactNode;
}

/** Renders a title, the number and some text on a card */
const Number = ({
  title,
  number,
  text,
  gap = 'none',
  layer = 1,
  testId,
}: Props): React.ReactElement => (
  <figure
    className={`bg-white flex flex-col items-center text-center p-6 gap--${gap} layer--${layer}`}
    data-testid={testId}
  >
    <strong className="uppercase skeletonize gap--m">{title}</strong>
    <Text size="6xl" className="font-bold">
      {number}
    </Text>
    <figcaption className="text-gray-500 text-sm skeletonize">{text}</figcaption>
  </figure>
);

export default Number;
